export default "__VITE_ASSET__DIDK4DyA__"